import { Text } from "@nju/ui";

interface IRowProps {
  title: string;
  value: string;
}

export function Row({ title, value }: IRowProps) {
  return (
    <>
      <Text
        display="block"
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
      >
        {title}
      </Text>
      <Text
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "l",
        }}
        weight="bold"
      >
        {value}
      </Text>
    </>
  );
}
